export const password = {
    'reset-text': 'Forgot your password? Enter your Email or Phone number and proceed with next step.',
    forgot: 'Forgot Password?',
    current: 'Current Password',
    new: 'New Password',
    repeat: 'Repeat New Password',
    reset: 'Reset Password',
    change: 'Change Password'
  };
  